import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../statics/stylesheet.css';
import { Helmet } from 'react-helmet';

export default class BreadCrumbsBar extends Component {
  static propTypes = {
    category: PropTypes.string,
    searchByOption: PropTypes.string,
    optionType: PropTypes.string,
    size: PropTypes.string
  }

  renderBreadCrumb = (breadCrumb, href, additionalText) => {
    return (
            <a
                className="breadcrumbbar__link"
                href={href.replace('#', '')} >
                    {breadCrumb != this.props.category && '  >  '} {additionalText} {breadCrumb}
            </a>
    );
  }

  render() {
    let { category, searchByOption, optionType, size } = this.props;
    const optionsForHref = optionType ? optionType.split(' ').join('%20') : '';

    size = searchByOption === 'Size' && optionType ? false : size;

    return (
            <div className="breadcrumbbar__categoryButtons">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Sorat Wheels & Tires: {category ? category : ''}{searchByOption ? ' By ' + searchByOption : ''}{optionType ? ' > ' + optionType.replace(/-/g, ' ').replace(/!/g, '-').replace(/_/g, '-') : ''}{size ? ' > ' + size : ''}</title>
                </Helmet>
                <span id="breadCrumbText" className="breadcrumbbar__categoryButtonsContainer">
                    { category && this.renderBreadCrumb(category, '#/')}
                    { searchByOption && this.renderBreadCrumb(searchByOption, '#/' + category.replace(/ /g, '%20'), 'Search By:') }
                    { optionType && this.renderBreadCrumb(optionType.replace(/-/g, ' ').replace(/!/g, '-').replace(/_/g, '-'), '#/' + category.replace(/ /g, '%20') + '/' + searchByOption, searchByOption === 'Size' ? 'Size: ' : '') }
                    { size && this.renderBreadCrumb(size, '#/' + category.replace(/ /g, '%20') + '/' + searchByOption + '/' + optionsForHref.split('/').join('%2F'), category === 'Tires' ? 'OEMS: ' : 'Size: ') }
                </span>
            </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/subcomponents/BreadCrumbsBar.js